<template>
  <div>
    <div class="card mb-5 mb-xl-10">
      <BlockUI :loading="block" />
      <div class="card-body pt-9 pb-0">
        <!--begin::Details-->
        <div class="d-flex flex-wrap flex-sm-nowrap mb-3">
          <!--begin: Pic-->
          <div class="me-7 mb-4">
            <div
              class="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative"
            >
              <img
                :src="
                  user.avatarUrl === null ? 'media/avatars/blank.png' : user.avatarUrl
                "
                alt="image"
              />
              <div
                class="position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px"
              ></div>
            </div>
          </div>
          <!--end::Pic-->

          <!--begin::Info-->
          <div class="flex-grow-1">
            <!--begin::Title-->
            <div class="d-flex justify-content-between align-items-start flex-wrap mb-2">
              <!--begin::User-->
              <div class="d-flex flex-column">
                <!--begin::Name-->
                <div class="d-flex align-items-center mb-2">
                  <a class="text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
                    >{{ user.firstName }} {{ user.lastName }}</a
                  >
                  <a>
                    <span
                      v-if="false"
                      :class="`${
                        user.active === true ? 'svg-icon svg-icon-1 svg-icon-primary' : ''
                      }`"
                      :title="
                        user.active === true ? translate('Active') : translate('Passive')
                      "
                    >
                      <inline-svg
                        :src="`${
                          user.active === true
                            ? 'media/icons/duotune/general/gen026.svg'
                            : 'media/icons/duotune/general/not-active.svg'
                        }`"
                      />
                    </span>
                  </a>
                </div>
                <!--end::Name-->

                <!--begin::Info-->
                <div class="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2">
                  <a
                    class="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
                  >
                    {{ user.countryName }}
                  </a>
                  <a
                    class="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
                  >
                    <span class="svg-icon svg-icon-4 me-1">
                      <inline-svg src="media/icons/duotune/general/gen018.svg" />
                    </span>
                    {{ user.cityName }}, {{ user.districtName }}
                  </a>
                  <a
                    :href="`mailto:${user.email}`"
                    class="d-flex align-items-center text-gray-400 text-hover-primary mb-2"
                  >
                    <span class="svg-icon svg-icon-4 me-1">
                      <inline-svg src="media/icons/duotune/communication/com011.svg" />
                    </span>
                    {{ user.email }}
                  </a>
                </div>
                <!--end::Info-->
              </div>
              <!--end::User-->

              <!--begin::Actions-->

              <!--end::Actions-->
            </div>

            <!--end::Stats-->
          </div>
          <!--end::Info-->
        </div>
        <!--end::Details-->

        <!--begin::Navs-->

        <!--begin::Navs-->
      </div>
    </div>
    <div
      class="card mb-5 mb-xl-10"
      id="profile_details_view"
    >
      <!--begin::Card header-->

      <!--// ! Detail::Card body End--><!-- // ! Edit User Form \\-->
      <div
        class="card-body p-9 pb-5"
        style=""
      >
        <Form
          v-slot="{ errors }"
          ref="updateForm"
          id="userprofileform"
          class="form"
          :validation-schema="userValidator"
          novalidate="novalidate"
          @submit="updateUserProfil()"
        >
          <div class="row mb-6">
            <!--begin::Label--><label class="col-lg-4 col-form-label fw-bold fs-6">{{
              translate("profile_photo")
            }}</label
            ><!--end::Label--><!--begin::Col-->
            <div class="col-lg-8">
              <!--begin::Image input-->
              <div
                class="image-input image-input-outline"
                data-kt-image-input="true"
                style="background-image: url(media/avatars/blank.png)"
              >
                <!--begin::Preview existing avatar-->
                <div
                  class="image-input-wrapper w-125px h-125px"
                  :style="
                    modelUser.avatarUrl === null
                      ? 'background-image: url(media/avatars/blank.png)'
                      : `background-image: url(${modelUser.avatarUrl})`
                  "
                  style="background-size: 100% 100%"
                ></div>
                <!--end::Preview existing avatar-->

                <!--begin::Label-->
                <label
                  class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow"
                  data-kt-image-input-action="change"
                  data-bs-toggle="tooltip"
                  :title="t('user_detail_edit_change_avatar')"
                >
                  <i class="bi bi-pencil-fill fs-7"></i>

                  <!--begin::Inputs-->
                  <input
                    type="file"
                    name="avatar"
                    accept=".jpg, .jpeg, .png"
                    @change="selectImage($event)"
                  />
                  <input
                    type="hidden"
                    name="avatar_remove"
                  />
                  <!--end::Inputs-->
                </label>
                <!--end::Label-->

                <!--begin::Remove-->
                <span
                  class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow"
                  data-kt-image-input-action="remove"
                  data-bs-toggle="tooltip"
                  @click="removeImage($event)"
                  :title="t('user_detail_edit_remove_avatar')"
                >
                  <i class="bi bi-x fs-2"></i>
                </span>
                <!--end::Remove-->

                <span
                  v-show="user.avatarUrl !== modelUser.avatarUrl"
                  class="btn bg-success btn-icon btn-circle btn-color-white w-35px h-35px bg-white shadow"
                  style="top: -10px; left: -10px"
                  data-kt-image-input-action="remove"
                  data-bs-toggle="tooltip"
                  @click="saveImage()"
                  :title="t('user_detail_edit_save_avatar')"
                >
                  <i
                    class="bi bi-check"
                    style="font-size: x-large"
                  ></i>
                </span>
              </div>
              <!--end::Image input--><!--begin::Hint-->
              <div class="form-text">Allowed file types: jpg, jpeg, png.</div>
              <!--end::Hint-->
            </div>
            <!--end::Col-->
          </div>

          <div class="row">
            <!--begin::Label-->
            <label class="col-lg-4 col-form-label required fw-bold fs-6">{{
              translate("user_modal_label_full_name")
            }}</label>
            <!--end::Label-->

            <!--begin::Col-->
            <div class="col-lg-8">
              <!--begin::Row-->
              <div class="row">
                <!--begin::Col-->
                <div class="col-lg-6 fv-row d-v-container">
                  <div class="fv-plugins-message-container d-v-content">
                    <div class="fv-help-block ms-2 v-element">
                      <ErrorMessage name="fname" />
                    </div>
                  </div>
                  <Field
                    type="text"
                    name="fname"
                    :class="errors['fname'] !== undefined ? 'v-invalid' : ''"
                    class="form-control form-control-lg fs-6"
                    :placeholder="translate('FirstName')"
                    v-model.trim="modelUser.firstName"
                  />
                </div>
                <!--end::Col-->

                <!--begin::Col-->
                <div class="col-lg-6 fv-row d-v-container">
                  <div class="fv-plugins-message-container d-v-content">
                    <div class="fv-help-block ms-2 v-element">
                      <ErrorMessage name="lname" />
                    </div>
                  </div>
                  <Field
                    type="text"
                    name="lname"
                    :class="errors['lname'] !== undefined ? 'v-invalid' : ''"
                    class="form-control form-control-lg fs-6"
                    :placeholder="translate('LastName')"
                    v-model.trim="modelUser.lastName"
                  />
                </div>
                <!--end::Col-->
              </div>
              <!--end::Row-->
            </div>
            <!--end::Col-->
          </div>

          <div class="row mb-4 mt-4">
            <label class="col-lg-4 col-form-label required fw-bold fs-6">{{
              translate("EMail")
            }}</label>

            <div class="col-lg-8 fv-row d-v-container">
              <div class="fv-plugins-message-container d-v-content">
                <div class="fv-help-block ms-2 v-element">
                  <ErrorMessage name="email" />
                </div>
              </div>
              <Field
                disabled
                type="text"
                name="email"
                :class="errors['email'] !== undefined ? 'v-invalid' : ''"
                class="form-control form-control-lg fs-6"
                :placeholder="translate('EMail')"
                v-model.trim="modelUser.email"
              />
            </div>
          </div>

          <div class="row mb-4">
            <label class="col-lg-4 col-form-label fw-bold fs-6">{{
              translate("PhoneNumber")
            }}</label>
            <div class="col-lg-8 fv-row">
              <Field
                type="text"
                name="phone"
                class="form-control form-control-lg fs-6"
                :placeholder="translate('PhoneNumber')"
                v-model="modelUser.phone"
              />
            </div>
          </div>

          <div class="row mb-4 position-raletive">
            <label class="col-lg-4 col-form-label required fw-bold fs-6">{{
              translate("user_modal_label_user_time_zone")
            }}</label>

            <div class="col-lg-8 fv-row d-v-container">
              <div
                class="fv-plugins-message-container d-v-content"
                style="z-index: 1"
              >
                <div
                  class="fv-help-block v-element"
                  style="margin-left: 0.35rem !important"
                >
                  <ErrorMessage name="timeZone" />
                </div>
              </div>

              <Field
                name="timeZone"
                v-model="modelUser.timezoneId"
              >
                <Dropdown
                  :filter="!platform"
                  :emptyFilterMessage="translate('No_Records')"
                  :showClear="true"
                  v-model="modelUser.timezoneId"
                  :options="timeZoneList"
                  optionLabel="Value"
                  optionValue="Id"
                  :placeholder="translate('user_modal_select_user_time_zone')"
                  style="padding: 5px !important"
                  :style="`${
                    errors['timeZone'] !== undefined
                      ? 'border-color: #f31f0c77 !important;'
                      : ''
                  }`"
                  appendTo="self"
                >
                </Dropdown>
              </Field>
            </div>
          </div>

          <div class="row mb-4">
            <label class="col-lg-4 col-form-label fw-bold fs-6">{{
              translate("Address")
            }}</label>
            <div class="col-lg-8">
              <!--begin::Row-->
              <div class="row">
                <!--begin::Col-->
                <div class="col-lg-4 fv-row">
                  <Dropdown
                    class="mb-3"
                    :filter="!platform"
                    :emptyFilterMessage="translate('No_Records')"
                    v-model="modelUser.countryId"
                    :options="CountryList"
                    optionLabel="Value"
                    optionValue="Id"
                    :placeholder="translate('CountrySelect')"
                    style="padding: 5px !important"
                    @change="getCity"
                    appendTo="self"
                  >
                    <template v-slot:indicator>
                      <div
                        class="p-dropdown-trigger"
                        role="button"
                        aria-haspopup="listbox"
                        aria-expanded="false"
                      >
                        <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>
                      </div>

                      <i
                        v-if="modelUser.countryId === 0 ? false : true"
                        class="p-dropdown-clear-icon pi pi-times"
                        @click="(modelUser.countryId = 0), getCity()"
                      ></i>
                    </template>
                  </Dropdown>
                </div>
                <div class="col-lg-4 fv-row">
                  <Dropdown
                    class="mb-3"
                    :filter="!platform"
                    :emptyFilterMessage="translate('No_Records')"
                    v-model="modelUser.cityId"
                    :options="CityList"
                    optionLabel="Value"
                    optionValue="Id"
                    :placeholder="translate('CitySelect')"
                    style="padding: 5px !important"
                    @change="getDistrict"
                    appendTo="self"
                  >
                    <template v-slot:indicator>
                      <div
                        class="p-dropdown-trigger"
                        role="button"
                        aria-haspopup="listbox"
                        aria-expanded="false"
                      >
                        <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>
                      </div>

                      <i
                        v-if="modelUser.cityId === 0 ? false : true"
                        class="p-dropdown-clear-icon pi pi-times"
                        @click="(modelUser.cityId = 0), getDistrict()"
                      ></i>
                    </template>
                  </Dropdown>
                </div>
                <div class="col-lg-4 fv-row">
                  <Dropdown
                    class="mb-3"
                    :filter="!platform"
                    :emptyFilterMessage="translate('No_Records')"
                    v-model="modelUser.districtId"
                    :options="DistrictList"
                    optionLabel="Value"
                    optionValue="Id"
                    :placeholder="translate('DistrictSelect')"
                    style="padding: 5px !important"
                    appendTo="self"
                  >
                    <template v-slot:indicator>
                      <div
                        class="p-dropdown-trigger"
                        role="button"
                        aria-haspopup="listbox"
                        aria-expanded="false"
                      >
                        <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>
                      </div>

                      <i
                        v-if="modelUser.districtId === 0 ? false : true"
                        class="p-dropdown-clear-icon pi pi-times"
                        @click="modelUser.districtId = 0"
                      ></i>
                    </template>
                  </Dropdown>
                </div>

                <!--end::Col-->
              </div>
              <!--end::Row-->
            </div>
          </div>
          <div class="row mb-4 justify-content-end">
            <div class="col-lg-8 fv-row">
              <input
                type="text"
                name="adress-detay"
                class="form-control form-control-lg fs-6"
                :placeholder="translate('AddressDetail')"
                v-model.trim="modelUser.streetAddress"
              />
            </div>
          </div>

          <div class="row mb-4">
            <label class="col-lg-4 col-form-label fw-bold fs-6">{{
              translate("user_modal_label_user_languge")
            }}</label>
            <div class="col-lg-8 fv-row">
              <Dropdown
                class="mb-3"
                :filter="!platform"
                :emptyFilterMessage="translate('No_Records')"
                v-model="modelUser.languageId"
                :options="laguageList"
                optionLabel="Value"
                optionValue="Id"
                :placeholder="translate('Select_Laguage')"
                style="padding: 5px !important"
                appendTo="self"
              >
                <template v-slot:indicator>
                  <div
                    class="p-dropdown-trigger"
                    role="button"
                    aria-haspopup="listbox"
                    aria-expanded="false"
                  >
                    <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>
                  </div>

                  <i
                    v-if="modelUser.languageId === 0 ? false : true"
                    class="p-dropdown-clear-icon pi pi-times"
                    @click="modelUser.languageId = 0"
                  ></i>
                </template>
              </Dropdown>
            </div>
          </div>

          <div class="row mb-7 align-items-center">
            <!--begin::Label-->
            <label class="col-lg-4 fw-bold text-gray-800"
              >{{ translate("user_detail_public_label_password") }}
            </label>
            <!--end::Label-->

            <!--begin::Col-->
            <div class="col-lg-8">
              <div class="d-flex justify-content-between align-items-center">
                <a
                  class="fw-bold fs-6 text-gray-800 text-hover-primary"
                  style="padding-top: 5px"
                  ><span> ****** </span>
                </a>
                <a
                  class="btn btn-color-gray-800 btn-active-light px-6 btn-sm border"
                  @click="cancelUpdatePassword"
                >
                  {{ translate("user_detail_comp_button_change_password") }}
                </a>
              </div>
            </div>
            <transition
              name="component-fade"
              mode="out-in"
            >
              <div
                v-if="showChangeMenu"
                class="row pe-0 pt-8"
              >
                <Form
                  v-slot="{ errors }"
                  id="kt_signin_change_password"
                  class="form p-0"
                  novalidate="novalidate"
                  @submit="updatePassword()"
                  :validation-schema="changePasswordValidator"
                  ref="passwordForm"
                >
                  <div class="row mb-5 ps-2">
                    <div class="col-lg-4">
                      <div class="fv-row mb-0">
                        <label
                          for="oldpassword"
                          class="form-label fs-7 mb-3 mx-1 text-gray-800"
                          >{{ translate("user_detail_comp_label_old_password") }}</label
                        >

                        <div class="fv-row d-v-container">
                          <div class="fv-plugins-message-container d-v-content">
                            <div
                              class="fv-help-block ms-2 v-element"
                              style="left: 4px"
                            >
                              <ErrorMessage name="oldpassword" />
                            </div>
                          </div>
                          <Field
                            type="password"
                            name="oldpassword"
                            id="oldpassword"
                            class="form-control form-control-sm fw-bold fs-6"
                            :class="
                              errors['oldpassword'] !== undefined ? 'v-invalid' : ''
                            "
                            v-model="editPassword.oldPassword"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <div class="fv-row mb-0">
                        <label
                          for="newpassword"
                          class="form-label fs-7 mb-3 text-gray-800"
                          >{{ translate("user_detail_comp_label_new_password") }}</label
                        >
                        <div class="fv-row d-v-container">
                          <div class="fv-plugins-message-container d-v-content">
                            <div
                              class="fv-help-block ms-2 v-element"
                              style="left: 4px"
                            >
                              <ErrorMessage name="newpassword" />
                            </div>
                          </div>
                          <Field
                            type="password"
                            name="newpassword"
                            id="newpassword"
                            class="form-control form-control-sm fw-bold fs-6"
                            :class="
                              errors['newpassword'] !== undefined ? 'v-invalid' : ''
                            "
                            v-model="editPassword.newPassword"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <div class="fv-row mb-0">
                        <label
                          for="confirmpassword"
                          class="form-label fs-7 mb-3 text-gray-800"
                          >{{
                            translate("user_detail_comp_label_comfirm_password")
                          }}</label
                        >

                        <div class="fv-row d-v-container">
                          <div class="fv-plugins-message-container d-v-content">
                            <div
                              class="fv-help-block ms-2 v-element"
                              style="left: 4px"
                            >
                              <ErrorMessage name="confirmpassword" />
                            </div>
                          </div>
                          <Field
                            type="password"
                            name="confirmpassword"
                            id="confirmpassword"
                            class="form-control form-control-sm fw-bold fs-6"
                            :class="
                              errors['confirmpassword'] !== undefined ? 'v-invalid' : ''
                            "
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="row align-items-center"
                    :class="
                      changePasswordTrue === true
                        ? 'justify-content-between'
                        : 'justify-content-end'
                    "
                  >
                    <transition
                      name="component-fade"
                      mode="out-in"
                    >
                      <div
                        v-show="changePasswordTrue"
                        class="col-lg-6 align-items-center"
                      >
                        <i class="bi bi-check-circle-fill fs-2 text-primary"></i>
                        <span class="ms-3 fs-7 text-gray-800">
                          {{ translate("user_detail_comp_label_ok_change_password") }}
                        </span>
                      </div>
                    </transition>
                    <transition
                      name="component-fade"
                      mode="out-in"
                    >
                      <div
                        v-show="passwordText"
                        class="col-lg-6 align-items-center"
                      >
                        <i class="bi bi-x-circle-fill fs-2 text-danger"></i>
                        <span class="ms-3 fs-7 text-gray-800">
                          {{ translate("confirm_profile_page") }}
                        </span>
                      </div>
                    </transition>
                    <div class="col-lg-6">
                      <div class="d-flex justify-content-end">
                        <button
                          id="kt_password_cancel"
                          type="reset"
                          @click="cancelUpdatePassword"
                          class="btn btn-color-gray-800 btn-active-light px-6 btn-sm border me-2"
                        >
                          {{ translate("Cancel") }}
                        </button>
                        <button
                          id="kt_password_submit"
                          type="submit"
                          ref="updatePasswordButton"
                          class="btn btn-primary btn-sm px-6"
                        >
                          <div
                            v-if="loadingButtonPassword"
                            class="spinner-border spinner-border-sm mx-1"
                          ></div>
                          <span class="indicator-label">
                            {{ translate("user_detail_comp_button_update_password") }}
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </transition>
            <!--end::Col-->
          </div>

          <!-- Buttons -->
          <div class="d-flex justify-content-end">
            <!--end::Card body--><a
              @click="cancelUpdateProfile"
              class="btn btn-color-gray-600 btn-active-light px-6 btn-sm border me-2"
              style=""
              >{{ translate("Cancel") }}</a
            ><button
              type="submit"
              class="btn btn-primary align-self-center btn-sm"
            >
              <div
                v-if="loadingButton"
                class="spinner-border spinner-border-sm mx-1"
              ></div>
              <span class="indicator-label">
                {{ translate("Save") }}
              </span>
            </button>
          </div>
        </Form>
      </div>
      <!-- // ! Edit User Form  End\\-->
    </div>
    <ConfirmPopup></ConfirmPopup>
  </div>
</template>

<script setup>
import { useConfirm } from "primevue/useconfirm";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { inject, reactive, ref, computed, onMounted, watch } from "vue";
import { useI18n } from "vue-i18n";
import { ErrorMessage, Field, Form } from "vee-validate";
import * as Yup from "yup";
import UsersModule from "@/store/modules/Users/UsersModule";
import { useStore } from "vuex";

const store = useStore();
const platform = store.state.platform;
const loadingButton = ref(false);
const loadingButtonPassword = ref(false);
const confirm = useConfirm();

// Multi Language
const { t, te, locale } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

const user = reactive({
  id: 0,
  firstName: null,
  lastName: null,
  email: null,
  active: null,
  districtId: 0,
  districtName: null,
  countryId: 0,
  countryName: null,
  cityId: 0,
  cityName: null,
  streetAddress: null,
  phone: null,
  languageId: 0,
  avatarUrl: null,
  timezoneId: null,
});

const modelUser = reactive({
  id: 0,
  firstName: null,
  lastName: null,
  email: null,
  active: null,
  districtId: 0,
  districtName: null,
  countryId: 0,
  countryName: null,
  cityId: 0,
  cityName: null,
  streetAddress: null,
  phone: null,
  languageId: 0,
  avatarUrl: null,
  timezoneId: null,
});
const userOnlineObj = computed(() => store.getters["AuthModule/_getUser"]);
const block = ref(true);

const getUserOnline = () => {
  store
    .dispatch("UsersModule/GET_USER", userOnlineObj.value.Id)
    .then((response) => {
      user.id = response.Id;
      user.firstName = response.Firstname;
      user.lastName = response.Lastname;
      user.email = response.Email;
      user.active = response.Active;
      user.districtId = response.DistrictId;
      user.districtName = response.DistrictName;
      user.countryId = response.CountryId;
      store.dispatch("LanguageModule/GET_CITYS", response.CountryId);
      user.countryName = response.CountryName;
      user.cityId = response.CityId;
      store.dispatch("LanguageModule/GET_DISTRICT", response.CityId);
      user.cityName = response.CityName;
      user.streetAddress = response.StreetAddress;
      user.phone = response.Phone;
      user.languageId = response.DefaultLanguageId;
      user.avatarUrl = response.AvatarUrl === "" ? null : response.AvatarUrl;
      user.timezoneId = response.TimezoneId;
      setCurrentPageBreadcrumbs(`${user.firstName + " " + user.lastName}`, [
        translate("profile_page_breadcrumbs"),
      ]);
    })
    .finally(() => {
      block.value = false;
    });
};

watch(locale, () => {
  setCurrentPageBreadcrumbs(`${user.firstName + " " + user.lastName}`, [
    translate("profile_page_breadcrumbs"),
  ]);
});

const showEditDetail = ref(false);
const updateForm = ref();
const loading = ref(false);

store.dispatch("LanguageModule/GET_LOCALİZATON");
const laguageList = computed(() => store.getters["LanguageModule/_getLocalizatonList"]);
//Adres İşlemleri
store.dispatch("LanguageModule/GET_ALL_COUNTRY");
const CountryList = computed(() => store.getters["LanguageModule/_getCountryList"]);
const CityList = computed(() => store.getters["LanguageModule/_getCityList"]);

const DistrictList = computed(() => store.getters["LanguageModule/_getDistrictList"]);

const getCity = () => {
  modelUser.cityId = 0;
  modelUser.districtId = 0;
  store.dispatch("LanguageModule/GET_CITYS", modelUser.countryId);
};
const getDistrict = () => {
  modelUser.districtId = 0;
  store.dispatch("LanguageModule/GET_DISTRICT", modelUser.cityId);
};

store.dispatch("UsersModule/GET_TIME_ZONES");
const timeZoneList = computed(() => store.getters["UsersModule/_getTimeZones"]);

// Validation and Change Password Form Ref
const changePasswordTrue = ref(false);
const showChangeMenu = ref(false);
const editPassword = reactive({
  oldPassword: "",
  newPassword: "",
});
const passwordForm = ref();
const changePasswordValidator = Yup.object().shape({
  oldpassword: Yup.string().required(t("profile_page_change_password_valid_oldpassword")),
  newpassword: Yup.string().required(translate("user_detail_valid_new_pasword")),
  confirmpassword: Yup.string()
    .required(translate("user_detail_valid_confim_pasword"))
    .oneOf(
      [Yup.ref("newpassword"), null],
      translate("user_detail_valid_not_confim_pasword")
    )
    .label("Password Confirmation"),
});

const cancelUpdatePassword = () => {
  showChangeMenu.value = !showChangeMenu.value;
  passwordForm.value.resetForm();
  editPassword.oldPassword = "";
  editPassword.newPassword = "";
};

const passwordText = ref(false);
const updatePassword = () => {
  loadingButtonPassword.value = true;
  UsersModule.actions
    .CHANGE_PUBLIC_PASSWORD(null, editPassword)
    .then((response) => {
      loadingButtonPassword.value = false;
      if (response.Success) {
        changePasswordTrue.value = true;
      } else {
        passwordText.value = true;
      }
    })
    .finally(() => {
      if (changePasswordTrue.value) {
        setTimeout(() => {
          changePasswordTrue.value = false;
          showChangeMenu.value = false;
          passwordForm.value.resetForm();
          editPassword.newPassword = "";
          editPassword.oldPassword = "";
        }, 2000);
      } else if (passwordText.value) {
        setTimeout(() => {
          passwordText.value = false;
        }, 2000);
      }
    });
};

const setForm = () => {
  Object.keys(modelUser).forEach((tag) => {
    modelUser[tag] = user[tag];
  });
};
watch(user, () => {
  setForm();
});

const updateUserProfil = () => {
  loadingButton.value = true;
  store.dispatch("UsersModule/UPDATE_PUBLIC_USER", modelUser).then((response) => {
    if (response) {
      getUserOnline();
      loadingButton.value = false;
    } else {
      setForm();
      loadingButton.value = false;
    }
  });
};
let imgX = null;
const selectImage = (event) => {
  imgX = null;
  imgX = event.target.files;
  if (imgX.length > 0) {
    modelUser.avatarUrl = URL.createObjectURL(imgX[0]);
  }
};
const removeImage = async (event) => {
  if (user.avatarUrl === modelUser.avatarUrl) {
    confirm.require({
      target: event.currentTarget,
      message: translate("confirm_delete_profile_image"),
      icon: "pi pi-exclamation-triangle",
      acceptLabel: translate("customer_location_confirm_acceptLabel"),
      rejectLabel: translate("customer_location_confirm_rejectLabel"),
      acceptClass: "btn btn-sm btn-primary",
      rejectClass: "btn btn-sm btn-light",
      accept: () => {
        store.dispatch("AuthModule/DELETE_PROFILE_IMAGE").then((response) => {
          if (response) {
            user.avatarUrl = null;
            modelUser.avatarUrl = null;
          }
        });
      },
      reject: () => {
        return;
      },
    });
  } else {
    modelUser.avatarUrl = user.avatarUrl;
  }
};

const saveImage = async () => {
  let formData = new FormData();
  formData.append("PictureFile", imgX[0]);
  let response = await store.dispatch("AuthModule/SAVE_PROFILE_IMAGE", formData);
  getUserOnline();
};

getUserOnline();

const cancelUpdateProfile = () => {
  store.dispatch("LanguageModule/GET_CITYS", user.countryId);
  store.dispatch("LanguageModule/GET_DISTRICT", user.cityId);
  setForm();
};

const userValidator = Yup.object().shape({
  fname: Yup.string().required(translate("user_modal_validation_fname")),
  lname: Yup.string().required(translate("user_modal_validation_lname")),
  email: Yup.string()
    .nullable()
    .required(translate("CustomerAdd_Valid_EMail"))
    .email(translate("CustomerAdd_Valid_EMailFormat")),
  timeZone: Yup.string()
    .nullable(true)
    .required(translate("user_modal_validation_time_zone")),
});
</script>

<style scoped>
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}

.component-fade-enter-from,
.component-fade-leave-to {
  opacity: 0;
}
</style>
